import { Component, OnInit } from '@angular/core';
import { AuthService } from '../../core/services/auth.service';
import { TopMenuService, MenuItem } from '../services/top-menu.service';
import { AppSettings } from '../../core';

@Component({
	selector: 'sm-frontend-top-menu',
	template: require('./sm-frontend-top-menu.component.html')
})
export class SmFrontendTopMenuComponent implements OnInit {
	menuItems: MenuItem[] = [];
	isLoggedIn = false;
	showLoginForm = false;
	subscription: any;

	public readonly AUKRO_URL = AppSettings.AUKRO_URL;

	constructor(private authService: AuthService, private topMenuService: TopMenuService) {
		topMenuService
			.getMenu('top')
			.subscribe(items => this.menuItems = items || []);

		this.isLoggedIn = authService.isLoggedIn();
	}

	ngOnInit() {
		let self = this;
		this.subscription = self.authService.onTokenChanged.subscribe((token) => {
			self.isLoggedIn = self.authService.isLoggedIn();
		});
	}

	ngOnDestroy() {
		this.subscription.unsubscribe();
	}

	toggleLoginForm() {
		this.showLoginForm = !this.showLoginForm;
	}
}


// WEBPACK FOOTER //
// ./node_modules/angular-router-loader/src!./node_modules/angular2-template-loader!./app/shared/components/sm-frontend-top-menu.component.ts